export const blockIconsHardwareKeyboardDoubleArrowDown = (
	<span className='material-symbols-outlined'>keyboard_double_arrow_down</span>
);
